import { render } from "./MigrateWizard.vue?vue&type=template&id=ef8d772c&scoped=true"
import script from "./MigrateWizard.vue?vue&type=script&lang=js"
export * from "./MigrateWizard.vue?vue&type=script&lang=js"

import "./MigrateWizard.vue?vue&type=style&index=0&id=ef8d772c&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef8d772c"]])

export default __exports__